<template>
    <div id="profile-page">
        <!-- PROFILE HEADER -->
        <!-- <div class="profile-header">
            <div class="relative">
                <div class="cover-container rounded-t-lg">
                    <img
                        :src="userInfo.profileBanner"
                        alt="user-profile-cover"
                        style="max-height: 450px; width: 100%"
                        class="responsive block"
                    />
                </div>
            </div>
        </div> -->

        <!-- COL AREA -->
        <div class="vx-row flex justify-center" id="user-data">
            <!-- COL 1 -->
            <div class="sm:w-10/12 md:w-9/12 lg:w-7/12 xl:w-6/12 m-5">
                <!-- ABOUT CARD -->
                <vx-card
                    title="Profile"
                    class="mt-base user-info"
                    :class="{
                        floatingMenu: mainLayoutType === 'horizontal' && windowWidth >= 1200
                    }"
                >
                    <div class="profile-img-container pointer-events-none">
                        <div>
                            <vs-avatar
                                class="user-profile-img"
                                :src="profile.profile"
                                size="85px"
                                style="z-index: 500"
                            />
                        </div>
                    </div>

                    <!-- OTEHR DATA -->
                    <div class="mt-5">
                        <h6>Name:</h6>
                        <template v-if="editMode">
                            <vs-input
                                class="mt-3 w-full"
                                placeholder="Enter First Name"
                                v-model="profile.firstName"
                            ></vs-input>
                            <!-- <vs-input class="mt-5 w-1/2" placeholder="Last Name" v-model="profile.lastName"></vs-input> -->
                        </template>

                        <p class="mt-2" v-else>
                            {{ profile.firstName }}
                            <!-- {{ profile.firstName + ' ' + profile.lastName }} -->
                        </p>
                    </div>

                    <!-- <div class="mt-5">
                        <h6>Job Title:</h6>
                        <template v-if="profile.roles && profile.roles.length >= 2">
                            <p v-for="role in profile.roles" :key="role">{{ role }}</p>
                        </template>
                        <template v-else>
                            <p>{{ profile.roles[0] }}</p>
                        </template>
                    </div> -->

                    <!-- <div class="mt-5">
                        <h6>Department:</h6>
                        <p>{{ profile.department }}</p>
                    </div>

                    <div class="mt-5">
                        <h6>Location:</h6>
                        <p>{{ profile.location }}</p>
                    </div> -->

                    <div class="mt-5">
                        <h6>Email:</h6>
                        <p class="mt-2">
                            <vs-input
                                class="mt-3 w-full"
                                v-if="editMode"
                                placeholder="Enter Email Address"
                                v-model="profile.email"
                            ></vs-input>
                            <a v-else :href="'mailto:' + profile.email">{{ profile.email }}</a>
                        </p>
                    </div>
                    <!-- <div class="mt-5">
                        <h6 class="mb-3">Subscription:</h6>
                        <template v-if="editMode">
                            <a href="" @click.prevent="subscriptionEdit = true">{{
                                local[0].name
                            }}</a>
                        </template>

                        <p class="mt-2" v-else>
                            {{ local[0].name ? local[0].name : 'No Subscription' }}
                        </p>
                    </div> -->
                    <div class="mt-5" v-if="editMode">
                        <h6>Old Password:</h6>
                        <p>
                            <vs-input
                                class="mt-3 w-full"
                                placeholder="Enter Old Password"
                                v-model="profile.password"
                                type="password"
                            ></vs-input>
                        </p>
                    </div>
                    <div class="mt-5" v-if="editMode">
                        <h6>New Password:</h6>
                        <p>
                            <vs-input
                                class="mt-3 w-full"
                                placeholder="Enter New Password"
                                v-model="profile.password"
                                type="password"
                            ></vs-input>
                        </p>
                    </div>

                    <!-- <div class="mt-5">
                        <h6>Work Phone:</h6>
                        <p>
                            <a :href="'tel:' + profile.workPhone">{{
                                profile.workPhone
                            }}</a>
                        </p>
                    </div>

                    <div class="mt-5">
                        <h6>Mobile:</h6>
                        <p>
                            <a :href="'tel:' + profile.mobilePhone">{{
                                profile.mobilePhone
                            }}</a>
                        </p>
                    </div> -->
                    <template slot="footer">
                        <div class="flex justify-end">
                            <!-- class="settingIcon" -->
                            <vx-action-icon
                                v-if="!editMode"
                                icon="EditIcon"
                                @click="editMode = true"
                            >
                            </vx-action-icon>
                            <div v-else>
                                <vs-button
                                    size="medium"
                                    class="mr-3"
                                    @click="save(), (editMode = false)"
                                    color="#9cd6bb"
                                >
                                    Save
                                </vs-button>
                                <vs-button
                                    size="medium"
                                    class="mr-3"
                                    @click="editMode = false"
                                    color="#ada6a6"
                                >
                                    Cancel
                                </vs-button>
                            </div>
                        </div>
                    </template>
                </vx-card>
            </div>

            <!-- COL 2 -->
            <!-- <div class="vx-col w-full lg:w-3/4">
                <vx-card
                    class="mt-base"
                    v-for="post in updateFeed"
                    v-bind:key="post.announcementID"
                >
                    <div> -->
            <!-- POST HEADER -->
            <!-- <div class="post-header flex justify-between mb-4">
                            <div class="flex items-center">
                                <div>
                                    <vs-avatar
                                        class="m-0"
                                        :src="post.image"
                                        size="45px"
                                    ></vs-avatar>
                                </div>
                                <div class="ml-4">
                                    <h6>{{ post.title }}</h6>
                                    <small
                                        >{{ post.dateTimeCreated | date(true) }} at
                                        {{ post.dateTimeCreated | time }}</small
                                    >
                                </div>
                            </div>
                        </div> -->

            <!-- POST CONTENT -->
            <!-- <div class="post-content">
                            <div v-html="post.body"></div>
                        </div>
                    </div>
                </vx-card>
            </div> -->

            <!-- COL 3 -->
            <!-- <div class="vx-col w-full lg:w-1/4">
                <vx-card title="Theme Customizer" class="mt-base">
                    <the-customizer />
                </vx-card>
            </div> -->
            <vs-prompt
                :active.sync="subscriptionEdit"
                title="Infomation of Subcription"
                acceptText="Cancel"
                @accept="cancelingSubscription"
                color="#9cd6bb"
            >
                <client-side-table
                    :columns="columns"
                    :search="false"
                    :hoverFlat="true"
                    :data="local"
                >
                </client-side-table>
                <!-- <table class="w-full">
                    <tr>
                        <th>Name</th>
                        <th>Description</th>
                    </tr>
                    <tr>
                        <td>Monthly</td>
                        <td>Monthly subcription</td>
                    </tr>
                </table> -->
            </vs-prompt>
            <vs-prompt
                :active.sync="cancelSubscription"
                title="Confirm Cancellation"
                acceptText="Confirm"
                @accept="confirmCancellation"
                color="#e05358"
            >
                <p>Would you confirm that you'd like to cancel the subscription?</p>
            </vs-prompt>
        </div>
    </div>
</template>

<script>
import TheCustomizer from '@/layouts/components/customizer/TheCustomizer.vue'
import ClientSideTable from '@/components/custom/ClientSideTable'

import { mapGetters } from 'vuex'

export default {
    name: 'user-profile',
    components: {
        TheCustomizer,
        ClientSideTable
    },
    data() {
        return {
            sidebarOpen: false,
            editMode: false,
            profile: {},
            columns: [
                { title: 'Name', value: 'name' },
                { title: 'Description', value: 'description' }
            ],
            subscriptionEdit: false,
            cancelSubscription: false,
            local: [
                {
                    name: 'Monthly Subsctiption',
                    description: 'This is monthly subscription.($6.99 per month)'
                }
            ]
        }
    },
    watch: {
        currentUser: {
            handler(val) {
                if (val) {
                    this.profile = val
                }
            },
            immediate: true
        }
    },
    computed: {
        ...mapGetters({
            currentUser: 'auth/current_user'
        }),
        windowWidth() {
            return this.$store.state.windowWidth
        },
        mainLayoutType() {
            return this.$store.state.mainLayoutType
        }
    },
    methods: {
        loadContent() {
            this.$vs.loading({
                background: this.backgroundLoading,
                color: this.colorLoading,
                container: '#button-load-more-posts',
                scale: 0.45
            })
            setTimeout(() => {
                this.$vs.loading.close('#button-load-more-posts > .con-vs-loading')
            }, 3000)
        },
        save() {
            this.$store.dispatch('user/updateSelf', this.profile)
        },
        cancelingSubscription() {
            this.cancelSubscription = true
        },
        confirmCancellation() {
            console.log('Confirm Cancellation!')
        }
    }
}
</script>

<style lang="scss">
@import '@/assets/scss/vuexy/pages/profile.scss';
</style>

<style scoped>
.floatingMenu {
    top: 12rem !important;
}
.user-info {
    position: -webkit-sticky;
    position: sticky;
    top: 8rem;
}
.settingIcon {
    position: absolute !important;
    right: 30px;
    bottom: 20px;
}
::v-deep .vs-dialog {
    min-width: 600px !important;
}
</style>
